import { render, staticRenderFns } from "./LogoutSettingList.vue?vue&type=template&id=22313f90&scoped=true"
import script from "./LogoutSettingList.vue?vue&type=script&lang=js"
export * from "./LogoutSettingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22313f90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22313f90')) {
      api.createRecord('22313f90', component.options)
    } else {
      api.reload('22313f90', component.options)
    }
    module.hot.accept("./LogoutSettingList.vue?vue&type=template&id=22313f90&scoped=true", function () {
      api.rerender('22313f90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/systemSet/LogoutSettingList.vue"
export default component.exports